/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { CertificateRequestProductDto } from "./CertificateRequestProductDto.ts"
import type { CertificateTypeDto } from "./CertificateTypeDto.ts"
import type { ProductionSiteDto } from "./ProductionSiteDto.ts"

export const certificateRequestDtoStatusEnum = {
  OPENED: "OPENED",
  SUBMITTED: "SUBMITTED",
  REJECTED: "REJECTED",
  ACCEPTED: "ACCEPTED",
  CANCELED: "CANCELED",
} as const

export type CertificateRequestDtoStatusEnumKey =
  (typeof certificateRequestDtoStatusEnum)[keyof typeof certificateRequestDtoStatusEnum]

export type CertificateRequestDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type string
   */
  status: CertificateRequestDtoStatusEnumKey
  /**
   * @type string
   */
  productPurchaseOrderReference: string
  /**
   * @type object
   */
  productionSite: ProductionSiteDto
  /**
   * @type object
   */
  type: CertificateTypeDto
  /**
   * @type string
   */
  rejectionMessage: string | null
  /**
   * @type object
   */
  product: CertificateRequestProductDto
}
